$(document).ready(function () {
  console.log("hfg");

  /* START get height of scrolling announcement bar for the new transparent header positioning */
  var firstAnnouncement = $('.shopify-section-group-header-group .scrolling-announcements').first();
  var announcementHeight = firstAnnouncement.outerHeight();
  $('#HeaderWrapper').css('top', announcementHeight + 'px');
  /* END get height of scrolling announcement bar for the new transparent header positioning */

  /* check for A/B parameter */
  var urlParams = new URLSearchParams(window.location.search); 
  var param = urlParams.get('v'); 
  console.log({ param });
  if ( param == "b" ) {
    $('body').addClass('optimize-b-test');
  }


  setTimeout(function () {
    console.log("manually set transition classes");
    $("body").addClass("loaded").removeClass("unloading");
  }, 1300);

  $(".recharge-subscription-widget").addClass("custom-gapstow-class");
  console.log("custom", $(".custom-subscribe-element"));
  $(".custom-subscribe-element").on("click", function () {
    console.log("custom1");
    var wrapper = $(this).closest(".custom-wrapper");
    $(".custom-wrapper").removeClass("custom-wrapper-active");
    wrapper.addClass("custom-wrapper-active");
    if (wrapper.hasClass("custom-subscribe-wrapper")) {
      console.log("wrapper", wrapper);
      $(".subscription-radio input").click();
    } else {
      $(".onetime-radio input").click();
    }
  });

  $(".modal--quick-shop").on(
    "click",
    ".custom-subscribe-element",
    function (e) {
      console.log("hello");
      var wrapper = $(this).closest(".custom-wrapper");
      console.log("hello", wrapper);

      $(".custom-wrapper").removeClass("custom-wrapper-active");
      wrapper.addClass("custom-wrapper-active");
    }
  );

  // grid-product-type-one-time-only
  $(".grid-product-type-one-time-only .modal--quick-shop").on(
    "click",
    ".btn.add-to-cart",
    function (e) {
      e.preventDefault();
      var parentWrapper = $(this).closest(".modal--quick-shop");
      var qtyEl = parentWrapper.find(".js-qty__num");
      var qty = qtyEl.val();
      var maxQty = parentWrapper.data("max-quantity") || null;
      var variantId = parentWrapper.attr("data-variant-id");
      addItemToCart(variantId, qty, 0, maxQty);
    }
  );

  $(".modal--quick-shop").on(
    "click",
    ".custom-subscribe-wrapper .custom-add-to-cart span",
    function (e) {
      e.preventDefault();
      var parentWrapper = $(this).closest(".modal--quick-shop");
      var qtyEl = parentWrapper.find(".js-qty__num");
      var qty = qtyEl.val();
      var maxQty = parentWrapper.data("max-quantity") || null;
      var variantId = parentWrapper.attr("data-variant-id");
      addItemToCart(variantId, qty, sellingPlanId, maxQty);
    }
  );

  $(".modal--quick-shop").on(
    "click",
    ".custom-onetime-wrapper .custom-add-to-cart span",
    function (e) {
      e.preventDefault();
      var parentWrapper = $(this).closest(".modal--quick-shop");
      var qtyEl = parentWrapper.find(".js-qty__num");
      var qty = qtyEl.val();
      var maxQty = parentWrapper.data("max-quantity") || null;
      var variantId = parentWrapper.attr("data-variant-id");
      addItemToCart(variantId, qty, 0, maxQty);
    }
  );

  $(".modal--quick-shop").on("change", "select", function (e) {
    var shoppingPlanId = this.value;
    var parentWrapper = $(this).closest(".custom-subscribe-wrapper");
    var customATC = parentWrapper.find("[data-custom-subscription-atc]");
    customATC.attr("data-selling-plan-id", shoppingPlanId);
  });

  $(".custom-add-to-cart span").on("click", function (e) {
    e.preventDefault();
    $(".rc-radio--active input").addClass("click-this");
    $(".rc-radio--active input").click();
    var sellingPlanId = $(this).attr("data-selling-plan-id");
    var atcButton = $(".product-block .btn.add-to-cart");
    var atcForm = atcButton.closest("form");
    console.log("atc");
    console.log(atcButton);
    console.log(atcForm);
    console.log(sellingPlanId);
    atcButton.addClass("found-button");
    atcButton.click();
  });
  $("[data-custom-subscription-atcxxx]").on("click", function (e) {
    e.preventDefault();
    var wrapper = $(this).closest(".custom-subscribe-wrapper");
    var select = wrapper.find("select");
    var sellingPlan = select.value;
    console.log({ sellingPlan });
  });

  function addItemToCart(variant_id, qty, selling_plan, max_qty) {
    console.log("gdc addItemToCart");
    if (selling_plan == 0) {
      data = {
        id: variant_id,
        quantity: qty,
        properties: {
          "_max-quantity": max_qty
        }
      };
    } else {
      data = {
        id: variant_id,
        quantity: qty,
        properties: {
          "_max-quantity": max_qty
        },
        selling_plan: selling_plan,
      };
    }
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log("added item to cart");
        //window.location.href = '/cart';
      },
    });
  }


});


https://havenhome-express.myshopify.com/?_ab=0&_fd=0&_sc=1&preview_theme_id=144730489072


document.addEventListener('DOMContentLoaded', function() {
  var elem = document.querySelector('.rotating-text-carousel');
  var autoplaySpeed = parseInt(elem.getAttribute('data-autoplay-speed')); 
  console.log({autoplaySpeed});
  if (elem) {
      var flkty = new Flickity(elem, {
          // options
          fade: true,
          pageDots: false,
          draggable: false,
          adaptiveHeight: true,
          prevNextButtons: false,
          autoPlay: autoplaySpeed,
          wrapAround: true
      });
      window.addEventListener('resize', function() {
        flkty.resize();  // Resize Flickity to adjust to the new container size
      });
  }
  /* client decided against the curtans */

  /* check for Novel app */
  
  /*
  const allElements = document.querySelectorAll('*');

  // Check each element's ID
  allElements.forEach(element => {
      if (element.id.includes('shopify-block-novel')) {
          // Add class 'novel-curtain-container' to the element
          element.classList.add('novel-curtain-container');

          // Create two new div elements for the curtains
          const rightCurtain = document.createElement('div');
          rightCurtain.className = 'novel-curtain novel-curtain-right';

          const leftCurtain = document.createElement('div');
          leftCurtain.className = 'novel-curtain novel-curtain-left';

          // Append the new divs to the current element
          element.appendChild(leftCurtain);
          element.appendChild(rightCurtain);
      }
  });
*/
});



/* custom select element */
var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
//console.log("start custom class", x, l);
var arrowIcon = `<svg aria-hidden="true" focusable="false" role="presentation" data-v-af3fed16="" width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.16949 9.69475L1.02825 10.5369C1.25424 10.7054 1.61582 10.7054 1.79661 10.5369L10.0226 2.91526L18.2034 10.5369C18.3842 10.7054 18.7458 10.7054 18.9718 10.5369L19.8305 9.69475C20.0565 9.48421 20.0565 9.18945 19.8305 8.9789L10.3842 0.136091C10.1582 -0.0323434 9.84181 -0.0323434 9.61582 0.136091L0.16949 8.9789C-0.056498 9.18944 -0.056498 9.4842 0.16949 9.69475Z" fill="#266041"></path></svg>`;
var icon = `<svg aria-hidden="true" focusable="false" role="presentation" data-custom-hook="find-me" class="icon-class" data-v-af3fed16="" width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.3666 1.41704C10.5959 1.26309 10.6569.952447 10.503.723201 10.349.493955 10.0384.432916 9.80914.586866L10.3666 1.41704ZM8.82927 5.57362C8.98323 5.80286 9.29387 5.8639 9.52311 5.70995 9.75236 5.556 9.8134 5.24536 9.65945 5.01611L8.82927 5.57362ZM7.51967 2.72664 7.24092 2.31156C7.01167 2.46551 6.95063 2.77615 7.10458 3.0054L7.51967 2.72664ZM9.80914.586866 7.24092 2.31156 7.79842 3.14173 10.3666 1.41704 9.80914.586866ZM7.10458 3.0054 8.82927 5.57362 9.65945 5.01611 7.93476 2.44789 7.10458 3.0054ZM5.11702 17.6358C4.89254 17.7966 4.84092 18.1089 5.00174 18.3334 5.16255 18.5579 5.4749 18.6095 5.69938 18.4487L5.11702 17.6358ZM6.52796 13.4346C6.36714 13.2101 6.0548 13.1585 5.83031 13.3193 5.60583 13.4801 5.55421 13.7925 5.71503 14.017L6.52796 13.4346ZM7.92308 16.2407 8.21426 16.6471C8.43874 16.4863 8.49036 16.174 8.32954 15.9495L7.92308 16.2407ZM5.69938 18.4487 8.21426 16.6471 7.6319 15.8342 5.11702 17.6358 5.69938 18.4487ZM8.32954 15.9495 6.52796 13.4346 5.71503 14.017 7.51661 16.5318 8.32954 15.9495Z" fill="#595959"></path> <path fill-rule="evenodd" lip-rule="evenodd" d="M4.07801 3.39201C1.94276 4.59085 0.5 6.87694 0.5 9.5C0.5 13.366 3.63401 16.5 7.5 16.5C7.59475 16.5 7.68907 16.4981 7.78291 16.4944L7.50173 15.5C7.50115 15.5 7.50058 15.5 7.5 15.5C4.18629 15.5 1.5 12.8137 1.5 9.5C1.5 7.33775 2.64376 5.44265 4.35927 4.38669L4.07801 3.39201ZM10.8501 14.4784C12.4487 13.4005 13.5 11.573 13.5 9.5C13.5 6.26909 10.9463 3.63464 7.7472 3.505L7.46304 2.5001C7.47536 2.50003 7.48767 2.5 7.5 2.5C11.366 2.5 14.5 5.63401 14.5 9.5C14.5 12.0351 13.1524 14.2555 11.1344 15.4838L10.8501 14.4784Z" fill="#595959"></path></svg>`;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  //console.log("start custom select", selElmnt, ll, icon);
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  var selectedHtml =
    "<span>" +
    selElmnt.options[selElmnt.selectedIndex].innerHTML +
    "</span><span class='dropdown-arrow'>" +
    arrowIcon +
    "</span>";
  a.innerHTML = selectedHtml;
  //console.log(selElmnt.options[selElmnt.selectedIndex].innerHTML);
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 0; j < ll; j++) {
    //console.log("loop", j, ll, {icon});
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML =
      icon +
      "<span class='custom-delivery-text'>" +
      selElmnt.options[j].innerHTML +
      "</span>";
    c.addEventListener("click", function (e) {
      console.log("click", e);
      /* When an item is clicked, update the original select box,
        and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      console.log({ s }, { h }, { sl });
      for (i = 0; i < sl; i++) {
        var temp1 = s.options[i].innerHTML;
        var temp2 = this.innerHTML;
        var temp3 = this.getElementsByClassName("custom-delivery-text")[0];
        var temp4 = temp3.innerHTML;
        //console.log({temp1}," vs ", {temp2}," and ",{temp4});
        /* if (s.options[i].innerHTML == this.innerHTML) { */
        if (s.options[i].innerHTML == temp3.innerHTML) {
          s.selectedIndex = i;
          /*h.innerHTML = temp3.innerHTML;*/
          h.innerHTML =
            "<span>" +
            temp3.innerHTML +
            "</span><span class='dropdown-arrow'>" +
            arrowIcon +
            "</span>";
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          console.log({ y }, { yl });
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    console.log(a);
    var selectValue = $(".custom-select select").val();
    console.log({ selectValue });
    $(".rc-selling-plans-dropdown__select").toggleClass("toggleClass");
    $(
      ".rc-selling-plans-dropdown__select option[value='" + selectValue + "']"
    ).prop("selected", true);
    $(".rc-selling-plans-dropdown__select").trigger("change");
    $('[name="selling_plan"]').val(selectValue);
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);

var target = document.querySelector("[data-product-blocks]");
var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    //console.log(mutation);
    // Check if the mutation added any new nodes
    if (mutation.addedNodes.length > 0) {
      // Loop through the added nodes
      for (var i = 0; i < mutation.addedNodes.length; i++) {
        var node = mutation.addedNodes[i];
        // Check if the node is an element and if it has a class containing the number 945
        //var t1 = node.className;
        //var dataAttribute = node.getAttribute('data-custom-hook');
        //console.log(node);
        //console.log(node.className);
        //console.log({t1});
        //console.log({dataAttribute});
        //if ( t1.baseVal ) {
        //  console.log("baseVal", t1.baseVal)
        //} else {
        //  console.log("no baseVal");
        //}
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          !node.hasAttribute("data-custom-hook")
        ) {
          if (node.className.indexOf("rc-widget") > -1) {
            console.log("rc go to town");
            var subPrice = $(".subscription-radio .rc-radio__price").html();
            $(".purchase-type-price-subscription").html(subPrice);
          }
        }
      }
    }
  });
});
const config = { attributes: true, childList: true, subtree: true };

if (target) {
  observer.observe(target, config);
}

// added by Brittany 09/22/2023
// listen for cart change using Rebuy's event listener, https://developers.rebuyengine.com/reference/cart-event-listeners

// document.addEventListener('cart:updated', (event) => {
//   alert("other cart")
// });
let cartUpdatedResolver;
const cartUpdatedPromise = new Promise((resolve) => {
    cartUpdatedResolver = resolve;
});

document.addEventListener('cart:updated', (event) => {
  if (cartUpdatedResolver) {
      cartUpdatedResolver();
      // Ensure the resolver is nullified or reset after being called, 
      // so it doesn't get called more than once.
      cartUpdatedResolver = null;
  }
});

if (document.querySelector('#CartPageForm')) {
  document.addEventListener('rebuy:cart.ready', function() {
    // Now we know that window.Rebuy.Cart is ready to be used.
    handleCartUpdates();
  
    document.addEventListener('rebuy:cart.change', async (event) => {
        await cartUpdatedPromise;
        setTimeout(() => {
          handleCartUpdates();
        }, 100);
    });
  });
} else {
  document.addEventListener('rebuy:cart.change', async (event) => {
    handleCartUpdates();
  });
}
document.addEventListener('rebuy:smartcart.show', (event) => {
  handleCartUpdates();
});

function handleCartUpdates() {
  let maxedOutItems = checkCart()
  let cartItems = window.Rebuy.Cart.getItems()
  //console.log('MAXED OUT ITEMS', maxedOutItems)
  //console.log('CART', cartItems)
  // clear out any existing messages first
  let existingMessages = document.querySelectorAll('.maxed-out-message')
  if(existingMessages.length > 0) {
    console.log("clearing messages")
    existingMessages.forEach(message => {
      message.remove()
    })
  }
  // if there are maxed out items and the class rebuy-modal-visible exists on the body element, add   a message to the cart element with the class `product-${item.handle}`
  if(maxedOutItems.length > 0 && document.body.classList.contains('rebuy-modal-visible') ||   maxedOutItems.length > 0 && document.querySelector('#CartPageForm')) {
    maxedOutItems.forEach(item => {
      let productElement = document.querySelector(`.product-${item.handle}`)
      if(productElement) {
        // if message for this item doesn't already exist, add it
        if(!productElement.querySelector('.maxed-out-message')) {
          let message = document.createElement('div')
          message.classList.add('maxed-out-message')
          message.innerHTML = `<p>You've reached the maximum quantity allowed for this item.</p>`
          productElement.appendChild(message)
        }
        // if js-qty__adjust--plus exists, disable it
        let plusButton = productElement.querySelector('.js-qty__adjust--plus')
        if(plusButton) {
          if (item.properties["_max-quantity"] <= item.quantity) {
            plusButton.setAttribute('disabled', true);
          } else {
            plusButton.removeAttribute('disabled');
          }
        }
      }
    })
  }
}

// create a function to check the cart for items where the line item property "_max-quantity" is equal to the quantity
function checkCart() {
  if (!window.Rebuy || !window.Rebuy.Cart) {
    console.error("Rebuy or Rebuy.Cart is not defined!");
    return [];
}

let Cart = window.Rebuy.Cart;
let cartItems = Cart.getItems();
let maxedOutItems = [];

cartItems.forEach(item => {
    //console.log(`Checking item ${item.handle}, variant id: ${item.variant_id}, quantity: ${item.quantity}, max: ${item.properties["_max-quantity"]}`);

    if (item.properties["_max-quantity"] == item.quantity) {
        //console.log(`Max quantity reached for ${item.handle}`);
        maxedOutItems.push(item);
    }
    
    if (item.properties["_max-quantity"] && item.properties["_max-quantity"] < item.quantity) {
        //console.log(`Adjusting quantity for ${item.handle} to max`);
        Cart.setItemQuantity(item, Number(item.properties["_max-quantity"]));
    }
});

return maxedOutItems;
}



/* variants as products */
document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.product-family-wrapper .product-family-link');
  const familyVarietySpan = document.getElementById('familyVariety');
  if (familyVarietySpan) {
    const originalText = familyVarietySpan.getAttribute('data-page-variety');
  }
  let mouseEnterTimeout;

  links.forEach(link => {
    link.addEventListener('mouseenter', function() {
      // Clear any existing timeout to prevent unwanted text changes
      clearTimeout(mouseEnterTimeout);
      console.log('Mouse entered', this.getAttribute('data-family-variety'));
      // Set a new timeout
      mouseEnterTimeout = setTimeout(() => {
        const variety = this.getAttribute('data-family-variety');
        console.log('Changing text to:', variety);
        familyVarietySpan.textContent = variety;
      }, 30); // Delay in milliseconds, adjust as needed
    });

    link.addEventListener('mouseleave', function() {
      // Clear the timeout if mouse leaves before the delay is over
      clearTimeout(mouseEnterTimeout);
      console.log('Mouse left', this.getAttribute('data-family-variety'));
      console.log('Resetting text to original:', originalText);
      // Immediately reset the text
      familyVarietySpan.textContent = originalText;
    });
  });
});

/* new subscriptions cards */
function addItemToCartNewSubscriptions(variant_id, qty, selling_plan) {
  var data = {
      id: variant_id,
      quantity: qty
  };

  if (selling_plan !== 0) {
      data.selling_plan = selling_plan;
  }

  jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
          console.log("added item to cart");
          //window.location.href = '/cart';
      },
  });
}

function handleSubscriptionsCardATC(event) {
  if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
    return; // Only handle Enter and Space keys
  }
  
  if (event.type === 'keydown') {
    event.preventDefault(); // Prevent default scrolling on Space key
  }
  
  const subscriptionsOptions = event.target.closest('.subscription-card').querySelector('.product-subscriptions-options');
  const variantId = event.target.getAttribute('data-variant-id');
  if (subscriptionsOptions) {
      const isOpen = subscriptionsOptions.classList.contains('subscription-options-open');
      const selectElement = subscriptionsOptions.querySelector('select');

      if (!isOpen) {
          // Add to cart with selling plan 0
          addItemToCartNewSubscriptions(variantId, 1, 0);
      } else if (selectElement) {
          // Add to cart with selected selling plan
          addItemToCartNewSubscriptions(variantId, 1, selectElement.value);
      }
  } else {
    // No subscription options - add as one-time purchase
    addItemToCartNewSubscriptions(variantId, 1, 0);
  }
}

document.addEventListener('click', function(event) {
  console.log('click', event.target);
  if (event.target.classList.contains('subscriptions-card-atc')) {
    handleSubscriptionsCardATC(event);
  }
});

// Add keyboard support for accessibility
document.addEventListener('keydown', function(event) {
  if (event.target.classList.contains('subscriptions-card-atc')) {
    handleSubscriptionsCardATC(event);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var wrapperSubCards = document.querySelector('.subscription-cards-wrapper');
  var flktySubs;
  var lastWidth;

  function initFlickity() {
    console.log("initFlickitySubs");
    if (flktySubs) {
      flktySubs.destroy();
    }
    flktySubs = new Flickity(wrapperSubCards, {
      resize: true,
      wrapAround: true,
      cellAlign: 'left',
      accessibility: true,
      setGallerySize: true,
      on: {
        ready: function() {
          console.log('Flickity ready');
          console.log(wrapperSubCards.offsetHeight);
          fixSubscriptionCardRoles();
          removeAriaHiddenFromVisibleCards();
        },
        change: function() {
          removeAriaHiddenFromVisibleCards();
        }
      },
      imagesLoaded: true
    });
  }

  function removeAriaHiddenFromVisibleCards() {
    if (!wrapperSubCards) return;
    
    const cards = wrapperSubCards.querySelectorAll('.subscription-card');
    cards.forEach(function(card) {
      const rect = card.getBoundingClientRect();
      const wrapperRect = wrapperSubCards.getBoundingClientRect();
      
      // Check if card is within the visible viewport of the carousel
      const isVisible = rect.left >= wrapperRect.left - 10 && 
                       rect.right <= wrapperRect.right + 10 &&
                       rect.width > 0;
      
      if (isVisible) {
        card.removeAttribute('aria-hidden');
      } else {
        card.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function fixSubscriptionCardRoles() {
    if (!wrapperSubCards) return;
    
    // Fix incorrect role="tabpanel" added by Flickity
    // These are carousel items, not tabs (Issues #60, #62)
    const cards = wrapperSubCards.querySelectorAll('.subscription-card');
    cards.forEach(function(card, index) {
      // Remove incorrect tabpanel role - these are carousel items, not tabs
      if (card.getAttribute('role') === 'tabpanel') {
        card.removeAttribute('role');
      }
      
      // Get product title from data attribute
      var productTitle = card.getAttribute('data-product-title') || card.querySelector('.product-title h2')?.textContent || '';
      
      // Set simple aria-label without "Slide X of Y" to avoid duplication
      if (productTitle) {
        card.setAttribute('aria-label', productTitle.trim());
      }
      
      // Remove aria-roledescription to prevent "Slide X of Y: Slide X of Y" duplication
      if (card.hasAttribute('aria-roledescription')) {
        card.removeAttribute('aria-roledescription');
      }
      
      // Note: The subscription-options-header buttons inside are NOT tabs
      // They are accordion/disclosure buttons (they have aria-expanded)
      // The audit tool may incorrectly flag them as needing tab roles
      // but they are correctly implemented as buttons with aria-expanded
    });
  }

  function setWrapperHeightSubs() {
    var currentHeight = wrapperSubCards.offsetHeight;
    console.log({currentHeight});
    // Set the height as an inline style to prevent collapsing
    wrapperSubCards.style.height = currentHeight + 'px';
  }

  function resizeTitles() {
    var titles = wrapperSubCards.querySelectorAll('.product-title h2');
    var maxHeight = 0;
    titles.forEach(function(title) {
      var titleHeight = title.getBoundingClientRect().height;
      if (titleHeight > maxHeight) {
        maxHeight = titleHeight;
      }
    });
    titles.forEach(function(title) {
      title.style.height = maxHeight + 'px';
    });
  }

  /*
    function handleResize() {
      initFlickity();
      resizeTitles();
    }
*/

  function handleResize() {
    console.log("handle resize");
    var newWidth = window.innerWidth;
    if (newWidth != lastWidth) {
      console.log("reinitflickity");
      lastWidth = newWidth;
      initFlickity();
      resizeTitles();
    } else {
      console.log("window width did not change so do not reinitflickity");
    }
  }



  if (wrapperSubCards) {
    initFlickity();
    resizeTitles();
    window.addEventListener('resize', handleResize);
  }

  var prevButton = document.querySelector('.custom-subs-carousel-prev');
  var nextButton = document.querySelector('.custom-subs-carousel-next');

  if (prevButton) {
      prevButton.addEventListener('click', function() {
          flktySubs.previous();
      });
  }

  if (nextButton) {
      nextButton.addEventListener('click', function() {
          flktySubs.next();
      });
  }

  var wrapperPress = document.querySelector('.press-carousel');
  var flktyPress;
  var prevButtonAttached = false;
  var nextButtonAttached = false;

  console.log({wrapperPress});

  function initFlickityPress() {
    if (flktyPress) {
      flktyPress.destroy();
    }
    flktyPress = new Flickity(wrapperPress, {
      wrapAround: true,
      cellAlign: 'center',
      pageDots: false,
      prevNextButtons: false,
      accessibility: true,
      imagesLoaded: true
    });
    
    // Update aria-hidden on carousel change for accessibility
    function updatePressAriaAttributes() {
      var cells = wrapperPress.querySelectorAll('.press-item');
      cells.forEach(function(cell, index) {
        if (index === flktyPress.selectedIndex) {
          cell.removeAttribute('aria-hidden');
        } else {
          cell.setAttribute('aria-hidden', 'true');
        }
      });
    }
    
    // Set initial aria-hidden attributes
    updatePressAriaAttributes();
    
    // Update on change
    flktyPress.on('change', updatePressAriaAttributes);
    
    var prevButton = document.querySelector('.custom-press-carousel-prev');
    var nextButton = document.querySelector('.custom-press-carousel-next');

    if (prevButton && !prevButtonAttached) {
      prevButton.addEventListener('click', function () {
        console.log("go to previous");
        flktyPress.previous();
      });
      prevButtonAttached = true;
    }
  
    if (nextButton && !nextButtonAttached) {
      nextButton.addEventListener('click', function () {
        console.log("go to next");
        flktyPress.next();
      });
      nextButtonAttached = true;
    }
  }

    if (wrapperPress) {
      initFlickityPress();
      //window.addEventListener('resize', initFlickityPress);
    }

});





((document, window) => {
  // Placeholder for the setupCollectionControls function
  function setupCollectionControls() {
    // Your setup logic here
    console.log('setupCollectionControls called');
  }

  const okeRenderedHandler = function(e) {

    if (e.detail.widget === 'badge') {
      const observer = new MutationObserver((mutations, obs) => {
        const reviewCountElement = document.querySelector('.oke-minimalBadge-count');
        const averageRatingElement = document.querySelector('.oke-minimalBadge-stars .oke-a11yText');
        const starsForegroundElement = document.querySelector('.oke-minimalBadge-stars');

        if (reviewCountElement && averageRatingElement && starsForegroundElement) {
          // Extract the review count
          const reviewCount = reviewCountElement ? reviewCountElement.textContent.trim() : 'N/A';
          
          // Extract the average rating
          const averageRating = averageRatingElement ? averageRatingElement.textContent.match(/Rated ([0-9.]+) out of 5 stars/)[1] : 'N/A';
          
          // Extract the HTML for the oke-stars-foreground
          const starsForegroundHTML = starsForegroundElement ? starsForegroundElement.innerHTML : 'N/A';

          // Find the #myBadgeCopy element
          const myBadgeCopyElement = document.getElementById('myBadgeCopy');
          if (myBadgeCopyElement) {
            // Inject the starsForegroundHTML
            const starsDiv = document.createElement('div');
            starsDiv.innerHTML = starsForegroundHTML;
            starsDiv.setAttribute('aria-hidden', 'true');
            myBadgeCopyElement.appendChild(starsDiv);
            
            // Add screen reader only text for accessibility
            const srOnlyText = document.createElement('span');
            srOnlyText.className = 'visually-hidden';
            srOnlyText.textContent = `Rated ${averageRating} out of 5 stars based on ${reviewCount} reviews`;
            myBadgeCopyElement.appendChild(srOnlyText);

            // Create and inject the rating and review count div
            const ratingDiv = document.createElement('div');
            ratingDiv.textContent = `${averageRating} / 5.0 (${reviewCount} reviews and counting!)`;
            myBadgeCopyElement.appendChild(ratingDiv);
          }

          setupCollectionControls();
          
          // Stop observing once we've got the required elements
          obs.disconnect();
        }
      });

      // Start observing the document for changes
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };

  document.addEventListener('oke-rendered', okeRenderedHandler);
  
  document.addEventListener('oke-rendered', function() {
    setTimeout(function() {
      const okeStarSvgs = document.querySelectorAll('svg[aria-hidden="true"][role="none"]');
      okeStarSvgs.forEach(function(svg) {
        const parentElement = svg.closest('[data-oke-badge], .oke-minimalBadge-stars, [class*="oke-"]');
        if (parentElement) {
          const ratingText = parentElement.querySelector('.oke-a11yText');
          if (ratingText) {
            const wrapper = svg.parentElement;
            // Hide decorative star graphics from screen readers
            // The .oke-a11yText element already provides the accessible text
            if (wrapper && !wrapper.hasAttribute('aria-hidden')) {
              wrapper.setAttribute('aria-hidden', 'true');
            }
          }
        }
      });
    }, 100);
  });
})(document, window);

// Comprehensive accessibility fixes
(function() {
  'use strict';
  
  // Run on DOM ready
  function runAccessibilityFixes() {
    
    // Fix 1: Ensure all interactive elements with icons have proper labels
    const iconsInButtons = document.querySelectorAll('button svg[aria-hidden="true"], a svg[aria-hidden="true"]');
    iconsInButtons.forEach(function(svg) {
      const parent = svg.closest('button, a');
      if (parent && !parent.hasAttribute('aria-label') && !parent.textContent.trim()) {
        const iconClass = svg.getAttribute('class') || '';
        if (iconClass.includes('icon-chevron')) {
          const isExpanded = parent.getAttribute('aria-expanded') === 'true';
          if (!parent.hasAttribute('aria-label')) {
            parent.setAttribute('aria-label', isExpanded ? 'Collapse' : 'Expand');
          }
        }
      }
    });
    
    // Fix 2: Ensure decorative SVGs in links have fallback
    const linksWithIcons = document.querySelectorAll('a svg[aria-hidden="true"]');
    linksWithIcons.forEach(function(svg) {
      const link = svg.closest('a');
      if (link) {
        const hasVisibleText = link.textContent.trim().length > 0;
        const hasTitle = link.hasAttribute('title');
        const hasAriaLabel = link.hasAttribute('aria-label');
        
        if (!hasVisibleText && !hasTitle && !hasAriaLabel) {
          const fallbackText = link.querySelector('.icon__fallback-text');
          if (fallbackText) {
            link.setAttribute('aria-label', fallbackText.textContent.trim());
          }
        }
      }
    });
    
    // Fix 3: Ensure Flickity instances don't break accessibility
    const flickitySlides = document.querySelectorAll('.flickity-enabled .flickity-slider > *');
    flickitySlides.forEach(function(slide) {
      if (slide.hasAttribute('aria-hidden')) {
        const computedStyle = window.getComputedStyle(slide);
        const isVisible = computedStyle.display !== 'none' && 
                         computedStyle.visibility !== 'hidden' && 
                         parseFloat(computedStyle.opacity) > 0;
        
        if (isVisible) {
          slide.removeAttribute('aria-hidden');
        }
      }
    });
  }
  
  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAccessibilityFixes);
  } else {
    runAccessibilityFixes();
  }
  
  // Also run after a delay to catch dynamically loaded content
  setTimeout(runAccessibilityFixes, 500);
  setTimeout(runAccessibilityFixes, 1500);
  
  // Watch for Flickity changes
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          const target = mutation.target;
          if (target.classList.contains('subscription-card') || 
              target.classList.contains('flickity-slider') ||
              target.closest('.subscription-cards-wrapper') ||
              target.closest('.press-carousel')) {
            
            const computedStyle = window.getComputedStyle(target);
            const isVisible = computedStyle.display !== 'none' && 
                             computedStyle.visibility !== 'hidden' && 
                             parseFloat(computedStyle.opacity) > 0;
            
            if (isVisible && target.hasAttribute('aria-hidden')) {
              target.removeAttribute('aria-hidden');
            }
          }
        }
      });
    });
    
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true
    });
  }
})();

// ========================================
// Accessibility Fix for Marquee Duplicates
// ========================================
(function() {
  'use strict';

  // Hide duplicate marquee copies from screen readers
  // The marquee3k library creates duplicate wrappers for infinite scroll effect
  // Only the original content should be accessible to screen readers
  function hideMarqueeDuplicates() {
    const marqueeCopies = document.querySelectorAll('.marquee3k__wrapper.marquee3k__copy');
    marqueeCopies.forEach(function(copy) {
      if (!copy.hasAttribute('aria-hidden')) {
        copy.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(hideMarqueeDuplicates, 100);
    });
  } else {
    setTimeout(hideMarqueeDuplicates, 100);
  }

  // Watch for dynamically added marquee elements
  if (window.MutationObserver) {
    const marqueeObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if added node is a marquee copy or contains marquee copies
              if (node.classList && node.classList.contains('marquee3k__copy')) {
                node.setAttribute('aria-hidden', 'true');
              } else if (node.querySelector) {
                const copies = node.querySelectorAll('.marquee3k__wrapper.marquee3k__copy');
                copies.forEach(function(copy) {
                  copy.setAttribute('aria-hidden', 'true');
                });
              }
            }
          });
        }
      });
    });

    // Start observing when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        marqueeObserver.observe(document.body, { 
          childList: true, 
          subtree: true 
        });
      });
    } else {
      marqueeObserver.observe(document.body, { 
        childList: true, 
        subtree: true 
      });
    }
  }
})();

// ========================================
// Accessibility Fix for Rebuy ARIA Labels
// ========================================
(function() {
  'use strict';

  // Fix Rebuy product links with generic text like "Shop Now"
  function fixRebuyProductLinks() {
    // Find all Rebuy product links that might have generic text
    const rebuyLinks = document.querySelectorAll('.rebuy-product-title-link, .rebuy-product__title-link, a.rebuy-product-title, [data-rebuy-id] a[href*="/products/"]');
    
    rebuyLinks.forEach(function(link) {
      const linkText = link.textContent.trim();
      
      // Only add aria-label if the link text is generic or if it doesn't already have one
      if (!link.hasAttribute('aria-label') && (linkText === 'Shop Now' || linkText === 'View' || linkText === 'Buy Now' || linkText === 'Add to Cart' || linkText === 'Shop' || linkText === 'Learn' || linkText === 'Learn More' || linkText === 'Click Here' || linkText === 'Read More')) {
        // Try to find the product title from nearby elements
        let productTitle = '';
        
        // Check parent elements for product title
        const productCard = link.closest('.rebuy-product, .rebuy-product-block, [data-rebuy-product-id], .rebuy-cart__flyout-item');
        if (productCard) {
          const titleElement = productCard.querySelector('.rebuy-product-title, .rebuy-product__title, [data-rebuy-product-title], h3, h4');
          if (titleElement && titleElement !== link) {
            productTitle = titleElement.textContent.trim();
          }
          
          // Also check for product title in data attributes
          if (!productTitle) {
            const titleAttr = productCard.getAttribute('data-product-title') || productCard.getAttribute('data-title');
            if (titleAttr) {
              productTitle = titleAttr;
            }
          }
        }
        
        // If we found a product title, use it in the aria-label
        if (productTitle) {
          link.setAttribute('aria-label', linkText + ' - ' + productTitle);
        } else {
          // Try to extract product name from href
          const href = link.getAttribute('href');
          if (href && href.includes('/products/')) {
            const productSlug = href.split('/products/')[1].split('?')[0].split('#')[0];
            const productName = productSlug.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            link.setAttribute('aria-label', linkText + ' - ' + productName);
          }
        }
      }
    });
  }
  
  // Fix generic button links throughout the site  
  function fixGenericButtonLinks() {
    // Find all button-like links with generic text that don't already have aria-label
    const genericLinks = document.querySelectorAll('a.btn:not([aria-label]), a[class*="button"]:not([aria-label])');
    
    genericLinks.forEach(function(link) {
      const linkText = link.textContent.trim();
      
      // Check if link text is generic
      if (linkText === 'Shop Now' || linkText === 'View' || linkText === 'Buy Now' || linkText === 'Shop' || linkText === 'Learn' || linkText === 'Learn More' || linkText === 'Click Here' || linkText === 'Read More') {
        // Try to find context from nearby headings or titles
        let contextText = '';
        
        // Look for nearby heading or title
        const section = link.closest('section, [class*="section"], .grid__item, .feature-row, .hero, [data-section-type]');
        if (section) {
          // Try h1-h4 headings
          const heading = section.querySelector('h1, h2, h3, h4, .h1, .h2, .h3, .h4, .section-header__title, .hero__title');
          if (heading && !heading.contains(link)) {
            contextText = heading.textContent.trim();
          }
        }
        
        // If we found context, add aria-label
        if (contextText) {
          link.setAttribute('aria-label', linkText + ' - ' + contextText);
        }
      }
    });
  }
  
  // Make it globally accessible for other functions
  window.fixRebuyProductLinks = fixRebuyProductLinks;

  // Fix missing ARIA label references for Rebuy quick view overlay
  function fixRebuyQuickViewAccessibility() {
    const overlay = document.getElementById('rebuy-quick-view-overlay');
    
    if (!overlay) return;

    // Check if overlay has aria-labelledby attribute
    const labelledBy = overlay.getAttribute('aria-labelledby');
    if (labelledBy && !document.getElementById(labelledBy)) {
      // Create the missing label element
      const labelElement = document.createElement('h2');
      labelElement.id = labelledBy;
      labelElement.className = 'visually-hidden'; // Screen reader only class
      labelElement.textContent = 'Quick View';
      
      // Insert at the beginning of the overlay
      overlay.insertBefore(labelElement, overlay.firstChild);
    }

    // Check if overlay has aria-describedby attribute
    const describedBy = overlay.getAttribute('aria-describedby');
    if (describedBy && !document.getElementById(describedBy)) {
      // Create the missing description element
      const descElement = document.createElement('div');
      descElement.id = describedBy;
      descElement.className = 'visually-hidden'; // Screen reader only class
      descElement.textContent = 'Product quick view dialog';
      
      // Insert after the label element if it exists, otherwise at the beginning
      const labelElement = document.getElementById(labelledBy);
      if (labelElement && labelElement.nextSibling) {
        overlay.insertBefore(descElement, labelElement.nextSibling);
      } else {
        overlay.insertBefore(descElement, overlay.firstChild);
      }
    }
  }

  // Run fix when Rebuy quick view is shown
  document.addEventListener('rebuy:modal.open', function() {
    setTimeout(fixRebuyQuickViewAccessibility, 50);
    setTimeout(fixRebuyProductLinks, 50);
  });

  // Run fix when Rebuy widgets are loaded
  document.addEventListener('rebuy:widget.loaded', function() {
    setTimeout(fixRebuyProductLinks, 100);
  });

  // Also use MutationObserver to catch any dynamically added Rebuy elements
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.id === 'rebuy-quick-view-overlay' || 
                (node.querySelector && node.querySelector('#rebuy-quick-view-overlay'))) {
              fixRebuyQuickViewAccessibility();
            }
            // Check for Rebuy product elements
            if (node.hasAttribute && node.hasAttribute('data-rebuy-id') || 
                node.classList && (node.classList.contains('rebuy-product') || node.classList.contains('rebuy-widget')) ||
                (node.querySelector && (node.querySelector('[data-rebuy-id]') || node.querySelector('.rebuy-product')))) {
              fixRebuyProductLinks();
            }
          }
        });
      }
    });
  });

  // Start observing when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
      fixRebuyQuickViewAccessibility(); // Initial check
      setTimeout(fixRebuyProductLinks, 500); // Initial check with delay for Rebuy to load
      setTimeout(fixRebuyProductLinks, 1500); // Additional check
    });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
    fixRebuyQuickViewAccessibility(); // Initial check
    setTimeout(fixRebuyProductLinks, 500); // Initial check with delay for Rebuy to load
    setTimeout(fixRebuyProductLinks, 1500); // Additional check
  }
})();

// ========================================
// Accessibility Fix for Third-Party Buttons
// ========================================
(function() {
  'use strict';

  // Fix 6: Flickity pagination dots - make them keyboard accessible
  function fixFlickityPaginationDots() {
    const dots = document.querySelectorAll('.flickity-page-dots .dot:not([role])');
    dots.forEach(function(dot, index) {
      // Add button role for screen readers
      dot.setAttribute('role', 'button');
      
      // Add tabindex for keyboard navigation
      if (!dot.hasAttribute('tabindex')) {
        dot.setAttribute('tabindex', '0');
      }
      
      // Add keyboard event listener if not already added
      if (!dot.hasAttribute('data-keyboard-enabled')) {
        dot.setAttribute('data-keyboard-enabled', 'true');
        
        dot.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            dot.click();
          }
        });
      }
    });
  }

  // Fix missing labels on dynamically loaded third-party buttons
  function fixThirdPartyButtonLabels() {
    // Fix 1: Subscription buttons (smsb-subscribe-button)
    const subscribeButtons = document.querySelectorAll('.smsb-subscribe-button[role="button"]:not([aria-label])');
    subscribeButtons.forEach(function(button) {
      // Check if button has visible text
      const visibleText = button.textContent.trim();
      if (!visibleText || visibleText.length === 0) {
        button.setAttribute('aria-label', 'Subscribe');
      }
    });

    // Fix 2: Klaviyo close buttons (already have aria-label, but check for consistency)
    const klaviyoCloseButtons = document.querySelectorAll('.klaviyo-close-form:not([aria-label])');
    klaviyoCloseButtons.forEach(function(button) {
      button.setAttribute('aria-label', 'Close dialog');
    });

    // Fix 3: Klaviyo submit buttons without labels
    const klaviyoButtons = document.querySelectorAll('button.kl-private-reset-css-Xuajs1:not([aria-label]):not(.klaviyo-close-form)');
    klaviyoButtons.forEach(function(button) {
      // Check if it's likely a submit button based on context
      const visibleText = button.textContent.trim();
      if (!visibleText || visibleText.length === 0) {
        // Check parent form or surrounding context
        const form = button.closest('form');
        if (form) {
          button.setAttribute('aria-label', 'Submit form');
        } else {
          button.setAttribute('aria-label', 'Button');
        }
      }
    });

    // Fix 4: Video play buttons (Novel, Videowise, or similar widgets) - CRITICAL FIX
    // Target all play button variations including styled-components classes
    const playButtonSelectors = [
      'button.styles__RoundPlayButtonWrapper-sc-1bhnu6k-1',
      'button[class*="RoundPlayButtonWrapper"]',
      'button .play-button',
      'button:has(.play-button)'
    ];
    
    playButtonSelectors.forEach(function(selector) {
      try {
        const buttons = document.querySelectorAll(selector);
        buttons.forEach(function(button) {
          if (!button.hasAttribute('aria-label')) {
            button.setAttribute('aria-label', 'Play video');
          }
        });
      } catch (e) {
        // Some selectors like :has() might not be supported in all browsers
      }
    });

    // Fix 5: Arrow wrapper divs used as carousel navigation buttons - CRITICAL FIX
    const arrowWrappers = document.querySelectorAll('.styles__ArrowWrapper-hjpjk9-0, [class*="ArrowWrapper"], .prev-button-wrapper, .next-button-wrapper');
    arrowWrappers.forEach(function(wrapper) {
      // Only fix if it's actually interactive (has click handlers or is clickable)
      const isClickable = wrapper.onclick || 
                         wrapper.hasAttribute('onclick') || 
                         wrapper.style.cursor === 'pointer' ||
                         window.getComputedStyle(wrapper).cursor === 'pointer';
      
      if (isClickable || wrapper.parentElement.classList.contains('flickity-button')) {
        // Add button role if not present
        if (!wrapper.hasAttribute('role')) {
          wrapper.setAttribute('role', 'button');
        }
        
        // Add aria-label based on the wrapper class
        if (!wrapper.hasAttribute('aria-label')) {
          if (wrapper.classList.contains('prev-button-wrapper') || 
              wrapper.classList.contains('fiaZpG') ||
              wrapper.querySelector('svg') && wrapper.textContent.includes('prev')) {
            wrapper.setAttribute('aria-label', 'Previous');
          } else if (wrapper.classList.contains('next-button-wrapper') || 
                    wrapper.classList.contains('fNRWDI')) {
            wrapper.setAttribute('aria-label', 'Next');
          } else {
            wrapper.setAttribute('aria-label', 'Navigate');
          }
        }
        
        // Add tabindex for keyboard accessibility
        if (!wrapper.hasAttribute('tabindex')) {
          wrapper.setAttribute('tabindex', '0');
        }
        
        // Add keyboard event handler if not already present
        if (!wrapper.hasAttribute('data-keyboard-enabled')) {
          wrapper.setAttribute('data-keyboard-enabled', 'true');
          wrapper.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              wrapper.click();
            }
          });
        }
      }
    });

    // Fix 6: Video.js text track displays - these should not be interactive
    const vjsTextTracks = document.querySelectorAll('.vjs-text-track-display');
    vjsTextTracks.forEach(function(element) {
      // Remove any inappropriate roles and ensure it's not in tab order
      if (element.hasAttribute('role') && element.getAttribute('role') === 'button') {
        element.removeAttribute('role');
      }
      // These are display elements, not interactive
      if (!element.hasAttribute('aria-live')) {
        element.setAttribute('aria-live', 'polite');
      }
      if (!element.hasAttribute('role')) {
        element.setAttribute('role', 'region');
      }
      if (!element.hasAttribute('aria-label')) {
        element.setAttribute('aria-label', 'Video captions');
      }
    });

    // Fix 7: Video.js poster divs - make them properly accessible
    const vjsPosters = document.querySelectorAll('.vjs-poster');
    vjsPosters.forEach(function(poster) {
      // If poster is clickable, ensure it has proper button role
      const isClickable = poster.hasAttribute('tabindex') && poster.getAttribute('tabindex') !== '-1';
      
      if (isClickable) {
        if (!poster.hasAttribute('role')) {
          poster.setAttribute('role', 'button');
        }
        if (!poster.hasAttribute('aria-label')) {
          poster.setAttribute('aria-label', 'Play video');
        }
        // Add keyboard support
        if (!poster.hasAttribute('data-keyboard-enabled')) {
          poster.setAttribute('data-keyboard-enabled', 'true');
          poster.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              poster.click();
            }
          });
        }
      } else {
        // Not interactive, ensure it's properly marked
        poster.setAttribute('aria-hidden', 'true');
      }
    });

    // Fix 8: Generic buttons with role="button" but no label
    const genericButtons = document.querySelectorAll('[role="button"]:not([aria-label]):not(button):not(a)');
    genericButtons.forEach(function(element) {
      const visibleText = element.textContent.trim();
      if (!visibleText || visibleText.length === 0) {
        // Only add label if truly empty
        const hasChildText = Array.from(element.children).some(child => child.textContent.trim().length > 0);
        if (!hasChildText) {
          element.setAttribute('aria-label', 'Button');
        }
      }
    });
    
    // Fix pagination dots whenever we run button label fixes
    fixFlickityPaginationDots();
    
    // Fix Rebuy product links
    if (typeof fixRebuyProductLinks === 'function') {
      // This function is defined in the Rebuy accessibility section
      // We'll call it here if Rebuy widgets are present
      if (document.querySelector('[data-rebuy-id], .rebuy-product, .rebuy-widget')) {
        fixRebuyProductLinks();
      }
    }
  }

  // Optimized: Run once on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixThirdPartyButtonLabels, 100);
      setTimeout(fixThirdPartyButtonLabels, 500);
      setTimeout(fixThirdPartyButtonLabels, 1500);
    });
  } else {
    setTimeout(fixThirdPartyButtonLabels, 100);
    setTimeout(fixThirdPartyButtonLabels, 500);
    setTimeout(fixThirdPartyButtonLabels, 1500);
  }

  // Optimized MutationObserver - only watch for specific third-party widgets
  if (window.MutationObserver) {
    let debounceTimer;
    const observer = new MutationObserver(function(mutations) {
      // Debounce to prevent excessive runs
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        let shouldRun = false;
        
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) { // Element node
                // Only run fix if specific third-party elements are added
                const classList = node.classList || [];
                const className = node.className || '';
                
                if (classList.contains('smsb-subscribe-button') ||
                    classList.contains('klaviyo-close-form') ||
                    classList.contains('kl-private-reset-css-Xuajs1') ||
                    classList.contains('flickity-page-dots') ||
                    classList.contains('dot') ||
                    classList.contains('vjs-text-track-display') ||
                    classList.contains('vjs-poster') ||
                    className.includes('RoundPlayButtonWrapper') ||
                    className.includes('ArrowWrapper') ||
                    className.includes('button-wrapper') ||
                    node.querySelector && (
                      node.querySelector('.smsb-subscribe-button') ||
                      node.querySelector('.klaviyo-close-form') ||
                      node.querySelector('.kl-private-reset-css-Xuajs1') ||
                      node.querySelector('[class*="RoundPlayButtonWrapper"]') ||
                      node.querySelector('[class*="ArrowWrapper"]') ||
                      node.querySelector('.play-button') ||
                      node.querySelector('.flickity-page-dots') ||
                      node.querySelector('.dot') ||
                      node.querySelector('.vjs-text-track-display') ||
                      node.querySelector('.vjs-poster') ||
                      node.querySelector('.prev-button-wrapper') ||
                      node.querySelector('.next-button-wrapper')
                    )
                  ) {
                  shouldRun = true;
                }
              }
            });
          }
        });
        
        if (shouldRun) {
          fixThirdPartyButtonLabels();
        }
      }, 200); // 200ms debounce
    });

    // Start observing when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    } else {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Listen for specific third-party widget events
  // Klaviyo forms
  document.addEventListener('klaviyoForms', function() {
    setTimeout(fixThirdPartyButtonLabels, 100);
  });

  // Novel/Videowise video player
  if (window.addEventListener) {
    window.addEventListener('message', function(event) {
      // Check if message is from video widget
      if (event.data && typeof event.data === 'string' && 
          (event.data.includes('novel') || event.data.includes('videowise') || 
           event.data.includes('video') || event.data.includes('play'))) {
        setTimeout(fixThirdPartyButtonLabels, 100);
      }
    });
  }

  // Video.js player ready events
  if (window.videojs) {
    // Hook into videojs ready event
    const originalVideojs = window.videojs;
    window.videojs = function() {
      const player = originalVideojs.apply(this, arguments);
      if (player && player.ready) {
        player.ready(function() {
          setTimeout(fixThirdPartyButtonLabels, 100);
        });
      }
      return player;
    };
  }

  // Listen for video player initialization
  document.addEventListener('play', function(e) {
    if (e.target.tagName === 'VIDEO') {
      setTimeout(fixThirdPartyButtonLabels, 100);
    }
  }, true);

  // Run pagination dot fixes on load and when carousels are initialized
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixFlickityPaginationDots, 200);
      setTimeout(fixFlickityPaginationDots, 800);
      setTimeout(fixFlickityPaginationDots, 2000);
    });
  } else {
    setTimeout(fixFlickityPaginationDots, 200);
    setTimeout(fixFlickityPaginationDots, 800);
    setTimeout(fixFlickityPaginationDots, 2000);
  }

  // Also run after Flickity events
  document.addEventListener('flickity-ready', function() {
    setTimeout(fixFlickityPaginationDots, 100);
  });
})();

/**
 * Accessibility Enhancement for Dynamic Forms
 * Ensures forms loaded via JS (Klaviyo, Yotpo, etc.) meet WCAG 2.1 SC 3.2.2
 * Notifies users when form controls cause automatic context changes
 */
(function initFormAccessibility() {
  'use strict';

  /**
   * Add accessibility attributes to a form element
   */
  function enhanceFormAccessibility(form) {
    // Skip if already enhanced
    if (form.hasAttribute('data-a11y-enhanced')) {
      return;
    }

    // Mark as enhanced to avoid duplicate processing
    form.setAttribute('data-a11y-enhanced', 'true');

    // Find all select elements that might auto-submit
    var selects = form.querySelectorAll('select');
    selects.forEach(function(select) {
      // Check if this select has auto-submit behavior
      var hasAutoSubmit = select.hasAttribute('onchange') || 
                         select.getAttribute('onchange') !== null;
      
      // Add description for any select in a form with aria-live (indicates dynamic behavior)
      var formHasAriaLive = form.hasAttribute('aria-live') || form.closest('[aria-live]');
      
      if (hasAutoSubmit || formHasAriaLive) {
        addAccessibilityDescription(select, 'Changing this option may automatically update the form');
      }
    });

    // Find all inputs that might trigger auto-submission
    var autoInputs = form.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    autoInputs.forEach(function(input) {
      // Check if input has auto-submit listeners
      var hasAutoSubmit = input.hasAttribute('onchange') || 
                         input.getAttribute('onchange') !== null;
      
      if (hasAutoSubmit) {
        var labelText = 'Selecting this option may automatically update or submit the form';
        addAccessibilityDescription(input, labelText);
      }
    });

    // Add role and aria-live if form updates dynamically
    if (form.hasAttribute('aria-live') && !form.hasAttribute('role')) {
      form.setAttribute('role', 'region');
    }

    // Ensure form has accessible label
    if (!form.hasAttribute('aria-label') && !form.hasAttribute('aria-labelledby')) {
      var formPurpose = getFormPurpose(form);
      if (formPurpose) {
        form.setAttribute('aria-label', formPurpose);
      }
    }
  }

  /**
   * Add visually-hidden description to form control
   */
  function addAccessibilityDescription(element, text) {
    if (element.hasAttribute('aria-describedby')) {
      return; // Already has description
    }

    var descId = 'a11y-desc-' + Math.random().toString(36).substr(2, 9);
    var description = document.createElement('span');
    description.id = descId;
    description.className = 'visually-hidden';
    description.textContent = text;
    
    // Insert description before element
    element.parentNode.insertBefore(description, element);
    element.setAttribute('aria-describedby', descId);
  }

  /**
   * Determine form purpose for accessible label
   */
  function getFormPurpose(form) {
    var classNames = form.className || '';
    
    if (classNames.includes('klaviyo')) {
      return 'Newsletter subscription form';
    }
    if (classNames.includes('yotpo') || classNames.includes('smsbump')) {
      return 'Email and SMS subscription form';
    }
    if (classNames.includes('newsletter')) {
      return 'Newsletter signup form';
    }
    if (classNames.includes('contact')) {
      return 'Contact form';
    }
    
    return null;
  }

  /**
   * Process all forms on the page
   */
  function processAllForms() {
    var forms = document.querySelectorAll('form');
    forms.forEach(function(form) {
      enhanceFormAccessibility(form);
    });
  }

  /**
   * Observe DOM for dynamically added forms
   */
  function observeDynamicForms() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          // Check if the added node is a form
          if (node.nodeType === 1) { // Element node
            if (node.tagName === 'FORM') {
              enhanceFormAccessibility(node);
            }
            // Check for forms within the added node
            var forms = node.querySelectorAll && node.querySelectorAll('form');
            if (forms) {
              forms.forEach(function(form) {
                enhanceFormAccessibility(form);
              });
            }
          }
        });
      });
    });

    // Start observing document for child list changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      processAllForms();
      observeDynamicForms();
    });
  } else {
    processAllForms();
    observeDynamicForms();
  }

  // Also process after a delay to catch late-loading forms
  setTimeout(processAllForms, 2000);
  setTimeout(processAllForms, 5000);
})();

/**
 * Accessibility enhancement for carousels and hidden elements
 * Ensures visually hidden elements are properly hidden from screen readers
 */
(function() {
  'use strict';

  /**
   * Update aria-hidden for press carousel items based on visibility
   */
  function updatePressCarouselAccessibility() {
    var pressCarousel = document.querySelector('.press-carousel');
    if (!pressCarousel) return;

    var items = pressCarousel.querySelectorAll('.press-item');
    items.forEach(function(item) {
      var rect = item.getBoundingClientRect();
      var isVisible = rect.left >= 0 && rect.right <= window.innerWidth;
      item.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });
  }

  /**
   * Update aria-hidden for subscription carousel items based on visibility
   */
  function updateSubscriptionCarouselAccessibility() {
    var subsCarousel = document.querySelector('.subscription-cards-wrapper');
    if (!subsCarousel) return;

    var items = subsCarousel.querySelectorAll('.subscription-card');
    items.forEach(function(item, index) {
      var rect = item.getBoundingClientRect();
      var isVisible = rect.left >= 0 && rect.right <= window.innerWidth;
      item.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      
      // Fix incorrect role="tabpanel" added by Flickity
      if (item.getAttribute('role') === 'tabpanel') {
        item.removeAttribute('role');
      }
      
      // Remove aria-roledescription to prevent duplicate announcements
      if (item.hasAttribute('aria-roledescription')) {
        item.removeAttribute('aria-roledescription');
      }
      
      // Preserve simple product title label
      var productTitle = item.getAttribute('data-product-title') || item.querySelector('.product-title h2')?.textContent || '';
      if (productTitle && !item.getAttribute('aria-label')) {
        item.setAttribute('aria-label', productTitle.trim());
      }
    });
  }

  /**
   * Hide third-party elements that are visually hidden
   */
  function hideThirdPartyElements() {
    // Hide Rebuy quick view dropdown when not visible
    var rebuyDropdown = document.getElementById('rebuy-quick-view-dropdown-search');
    if (rebuyDropdown) {
      var computedStyle = window.getComputedStyle(rebuyDropdown);
      if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || 
          rebuyDropdown.offsetParent === null) {
        rebuyDropdown.setAttribute('aria-hidden', 'true');
      }
    }

    // Hide any sections with index-section--hidden class
    var hiddenSections = document.querySelectorAll('.index-section--hidden');
    hiddenSections.forEach(function(section) {
      var computedStyle = window.getComputedStyle(section);
      if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || 
          section.offsetParent === null) {
        if (!section.hasAttribute('aria-hidden')) {
          section.setAttribute('aria-hidden', 'true');
        }
      }
    });

    // Hide empty index-section divs
    var indexSections = document.querySelectorAll('.index-section');
    indexSections.forEach(function(section) {
      if (section.children.length === 0 || section.textContent.trim() === '') {
        section.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /**
   * Set up carousel navigation button click handlers
   */
  function setupCarouselHandlers() {
    // Press carousel navigation
    var pressPrev = document.querySelector('.custom-press-carousel-prev');
    var pressNext = document.querySelector('.custom-press-carousel-next');
    if (pressPrev) {
      pressPrev.addEventListener('click', function() {
        setTimeout(updatePressCarouselAccessibility, 100);
      });
    }
    if (pressNext) {
      pressNext.addEventListener('click', function() {
        setTimeout(updatePressCarouselAccessibility, 100);
      });
    }

    // Subscription carousel navigation
    var subsPrev = document.querySelector('.custom-subs-carousel-prev');
    var subsNext = document.querySelector('.custom-subs-carousel-next');
    if (subsPrev) {
      subsPrev.addEventListener('click', function() {
        setTimeout(updateSubscriptionCarouselAccessibility, 100);
      });
    }
    if (subsNext) {
      subsNext.addEventListener('click', function() {
        setTimeout(updateSubscriptionCarouselAccessibility, 100);
      });
    }
  }

  /**
   * Initialize all accessibility enhancements
   */
  function initAccessibility() {
    updatePressCarouselAccessibility();
    updateSubscriptionCarouselAccessibility();
    hideThirdPartyElements();
    setupCarouselHandlers();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccessibility);
  } else {
    initAccessibility();
  }

  // Re-check after page is fully loaded (for third-party scripts)
  window.addEventListener('load', function() {
    setTimeout(hideThirdPartyElements, 500);
    setTimeout(hideThirdPartyElements, 2000);
    setTimeout(hideThirdPartyElements, 5000);
  });

  // Monitor DOM changes for dynamically added elements
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        hideThirdPartyElements();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Additional accessibility fix for decorative SVGs in custom elements
(function() {
  function fixCustomSVGAccessibility() {
    // Target SVGs in custom select dropdowns and other custom elements
    var customSvgs = document.querySelectorAll('.dropdown-arrow svg, .icon-class, .custom-select svg, .select-items svg');
    
    customSvgs.forEach(function(svg) {
      if (!svg.hasAttribute('aria-hidden') || svg.getAttribute('aria-hidden') !== 'true') {
        svg.setAttribute('aria-hidden', 'true');
      }
      if (!svg.hasAttribute('focusable') || svg.getAttribute('focusable') !== 'false') {
        svg.setAttribute('focusable', 'false');
      }
      if (!svg.hasAttribute('role') || svg.getAttribute('role') !== 'presentation') {
        svg.setAttribute('role', 'presentation');
      }
    });
  }
  
  // Run after custom selects are initialized
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixCustomSVGAccessibility, 100);
      setTimeout(fixCustomSVGAccessibility, 500);
    });
  } else {
    setTimeout(fixCustomSVGAccessibility, 100);
    setTimeout(fixCustomSVGAccessibility, 500);
  }
})();

// ========================================
// Comprehensive Accessibility Fixes for All Reported Issues
// ========================================
(function() {
  'use strict';
  
  /**
   * Fix #15: Add labels to video play buttons (Novel/Benovel video players)
   */
  function fixVideoPlayButtons() {
    // Target Novel/Benovel video play buttons - specific classes from Issue #15
    var playButtons = document.querySelectorAll('button.styles__RoundPlayButtonWrapper-sc-1bhnu6k-1, button.gciwRz, button[class*="RoundPlayButton"], .play-button button, button[class*="play-button"]');
    
    playButtons.forEach(function(button) {
      if (!button.hasAttribute('aria-label') && !button.getAttribute('title')) {
        // Check if button has visible text
        var hasVisibleText = false;
        var textContent = button.textContent.trim();
        if (textContent && textContent.length > 0) {
          // Check if text is actually visible (not hidden by CSS)
          var spans = button.querySelectorAll('span');
          for (var i = 0; i < spans.length; i++) {
            var spanStyle = window.getComputedStyle(spans[i]);
            if (spanStyle.display !== 'none' && spanStyle.visibility !== 'hidden') {
              hasVisibleText = true;
              break;
            }
          }
        }
        
        // Only add aria-label if there's no visible text
        if (!hasVisibleText) {
          button.setAttribute('aria-label', 'Play video');
          button.setAttribute('title', 'Play video');
        }
      }
    });
    
    // Also fix any button without text content inside video players
    var videoContainers = document.querySelectorAll('[class*="video"], .vjs-tech, video');
    videoContainers.forEach(function(container) {
      var buttons = container.querySelectorAll('button:not([aria-label])');
      buttons.forEach(function(btn) {
        var text = btn.textContent.trim();
        if (!text || text.length === 0) {
          // Check for common video control classes
          if (btn.classList.contains('vjs-play-control') || btn.closest('.vjs-play-control')) {
            btn.setAttribute('aria-label', 'Play/Pause');
          } else if (btn.classList.contains('vjs-mute-control') || btn.closest('.vjs-mute-control')) {
            btn.setAttribute('aria-label', 'Mute/Unmute');
          } else if (btn.classList.contains('vjs-fullscreen-control') || btn.closest('.vjs-fullscreen-control')) {
            btn.setAttribute('aria-label', 'Fullscreen');
          } else {
            btn.setAttribute('aria-label', 'Video control');
          }
        }
      });
    });
  }
  
  /**
   * Fix #16: Add role="button" to interactive carousel navigation elements
   */
  function fixCarouselNavigationRoles() {
    // Fix carousel navigation arrows that look like buttons but aren't
    var navElements = document.querySelectorAll('.styles__ArrowWrapper-hjpjk9-0, .prev-button-wrapper, .next-button-wrapper, [class*="arrow-wrapper"]');
    
    navElements.forEach(function(element) {
      // Only add role if it's not already a button and doesn't have a role
      if (element.tagName !== 'BUTTON' && !element.hasAttribute('role')) {
        element.setAttribute('role', 'button');
        element.setAttribute('tabindex', '0');
        
        // Add appropriate label based on class
        if (!element.hasAttribute('aria-label')) {
          if (element.classList.contains('prev-button-wrapper') || element.classList.contains('styles__Wrapper-sc-1dnkca7-0')) {
            element.setAttribute('aria-label', 'Previous');
          } else if (element.classList.contains('next-button-wrapper') || element.classList.contains('styles__Wrapper-sc-1bgmk82-0')) {
            element.setAttribute('aria-label', 'Next');
          } else {
            element.setAttribute('aria-label', 'Navigate');
          }
        }
        
        // Add keyboard support
        if (!element.hasAttribute('data-keyboard-added')) {
          element.setAttribute('data-keyboard-added', 'true');
          element.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              element.click();
            }
          });
        }
      }
    });
    
    // Fix vjs-text-track-display elements that should not be interactive (Issue #16 items 2-6, 8)
    var textTrackDisplays = document.querySelectorAll('.vjs-text-track-display');
    textTrackDisplays.forEach(function(display) {
      // These are for captions/subtitles display, not interactive elements
      // Remove any role that makes it seem interactive
      if (display.hasAttribute('role')) {
        var currentRole = display.getAttribute('role');
        if (currentRole !== 'region' && currentRole !== 'status') {
          display.removeAttribute('role');
        }
      }
      // Ensure it's not in tab order
      if (display.hasAttribute('tabindex') && display.getAttribute('tabindex') !== '-1') {
        display.setAttribute('tabindex', '-1');
      }
      // Make sure it's not treated as a button
      if (display.style.cursor === 'pointer') {
        display.style.cursor = 'default';
      }
    });
    
    // Fix vjs-poster elements (Issue #16 item 7)
    var posterElements = document.querySelectorAll('.vjs-poster');
    posterElements.forEach(function(poster) {
      // Poster should not be interactive unless it's meant to play the video
      if (poster.getAttribute('tabindex') === '-1' && poster.getAttribute('aria-disabled') === 'false') {
        // This is a clickable poster, ensure it has proper role and label
        if (!poster.hasAttribute('role')) {
          poster.setAttribute('role', 'button');
        }
        if (!poster.hasAttribute('aria-label')) {
          poster.setAttribute('aria-label', 'Play video');
        }
      } else if (poster.hasAttribute('tabindex') && poster.getAttribute('tabindex') !== '-1') {
        // Should not be in normal tab order
        poster.setAttribute('tabindex', '-1');
      }
    });
  }
  
  /**
   * Fix #22: Add context to generic "Shop Now" links
   */
  function fixGenericShopNowLinks() {
    var shopNowLinks = document.querySelectorAll('a');
    
    shopNowLinks.forEach(function(link) {
      var linkText = link.textContent.trim();
      
      // Only fix links with generic text that don't already have aria-label
      if ((linkText === 'Shop Now' || linkText === 'Learn More' || linkText === 'View' || linkText === 'Click Here') && !link.hasAttribute('aria-label')) {
        // Try to find context from nearby elements
        var context = '';
        
        // Check for nearby heading
        var section = link.closest('section, [class*="section"], .grid__item, .hero, [data-section-type]');
        if (section) {
          var heading = section.querySelector('h1, h2, h3, h4, .section-header__title, .hero__title');
          if (heading && !heading.contains(link)) {
            context = heading.textContent.trim();
          }
        }
        
        // Check for collection context
        if (!context && link.href && link.href.includes('/collections/')) {
          var collectionSlug = link.href.split('/collections/')[1];
          if (collectionSlug) {
            collectionSlug = collectionSlug.split('?')[0].split('#')[0].split('/')[0];
            context = collectionSlug.replace(/-/g, ' ').replace(/\b\w/g, function(l) { return l.toUpperCase(); });
          }
        }
        
        // Add aria-label with context
        if (context) {
          link.setAttribute('aria-label', linkText + ' - ' + context);
        }
      }
    });
  }
  
  /**
   * Fix #46: Ensure decorative SVGs and images are hidden from screen readers
   */
  function fixDecorativeSVGs() {
    // Fix SVGs in carousel navigation (Issue #46 items 1, 7)
    var navSvgs = document.querySelectorAll('.styles__ArrowWrapper-hjpjk9-0 svg, .prev-button-wrapper svg, .next-button-wrapper svg, [class*="arrow-wrapper"] svg, .fzydip svg, .fiaZpG svg, .fNRWDI svg');
    navSvgs.forEach(function(svg) {
      if (!svg.hasAttribute('aria-hidden')) {
        svg.setAttribute('aria-hidden', 'true');
      }
      if (!svg.hasAttribute('focusable')) {
        svg.setAttribute('focusable', 'false');
      }
      if (!svg.hasAttribute('role')) {
        svg.setAttribute('role', 'presentation');
      }
    });
    
    // Fix play button SVGs (Issue #46 items 2-6)
    var playButtonSvgs = document.querySelectorAll('.play-button svg, button[class*="play"] svg, button[class*="PlayButton"] svg, .styles__Wrapper-sc-14kbn7p-0 svg, .kOYTBL svg, button.gciwRz svg');
    playButtonSvgs.forEach(function(svg) {
      if (!svg.hasAttribute('aria-hidden')) {
        svg.setAttribute('aria-hidden', 'true');
      }
      if (!svg.hasAttribute('focusable')) {
        svg.setAttribute('focusable', 'false');
      }
      if (!svg.hasAttribute('role')) {
        svg.setAttribute('role', 'presentation');
      }
    });
    
    // Fix all SVGs without role or with role="presentation" to be hidden
    var allSvgs = document.querySelectorAll('svg:not([role="img"]):not([aria-label]):not([aria-labelledby])');
    allSvgs.forEach(function(svg) {
      // Check if SVG is inside a button or link that has a label
      var parent = svg.closest('button, a');
      if (parent && (parent.hasAttribute('aria-label') || parent.textContent.trim().length > 0)) {
        // This SVG is decorative
        if (!svg.hasAttribute('aria-hidden')) {
          svg.setAttribute('aria-hidden', 'true');
        }
        if (!svg.hasAttribute('focusable')) {
          svg.setAttribute('focusable', 'false');
        }
        if (!svg.hasAttribute('role')) {
          svg.setAttribute('role', 'presentation');
        }
      }
    });
  }
  
  /**
   * Fix #12 & #13: Properly manage aria-hidden on visible/hidden content
   */
  function fixAriaHiddenOnContent() {
    // Fix marquee copies - duplicates should be hidden
    var marqueeCopies = document.querySelectorAll('.marquee3k__wrapper.marquee3k__copy');
    marqueeCopies.forEach(function(copy) {
      if (!copy.hasAttribute('aria-hidden')) {
        copy.setAttribute('aria-hidden', 'true');
      }
    });
    
    // Fix animation-contents that are visible (Issue #12 item 4)
    var animationContents = document.querySelectorAll('.animation-contents[aria-hidden="true"]');
    animationContents.forEach(function(element) {
      var style = window.getComputedStyle(element);
      var isVisible = style.display !== 'none' && 
                     style.visibility !== 'hidden' && 
                     style.opacity !== '0' &&
                     element.offsetParent !== null;
      
      // If the animation content is visible, it should not be aria-hidden
      if (isVisible) {
        element.removeAttribute('aria-hidden');
      }
    });
    
    // Fix press items that are off-screen but shouldn't be in accessibility tree
    var pressItems = document.querySelectorAll('.press-item');
    pressItems.forEach(function(item) {
      var style = window.getComputedStyle(item);
      var transform = style.transform;
      
      // Check if item is transformed off-screen
      if (transform && transform !== 'none') {
        var isOffScreen = style.position === 'absolute' && 
                         (transform.includes('translateX(100%)') || 
                          transform.includes('translateX(200%)') ||
                          transform.includes('translateX(300%)'));
        
        if (isOffScreen && !item.hasAttribute('aria-hidden')) {
          item.setAttribute('aria-hidden', 'true');
        } else if (!isOffScreen && item.getAttribute('aria-hidden') === 'true') {
          item.removeAttribute('aria-hidden');
        }
      }
    });
    
    // Fix Rebuy dropdown when not visible (Issue #13 item 1)
    var rebuyDropdown = document.getElementById('rebuy-quick-view-dropdown-search');
    if (rebuyDropdown) {
      var style = window.getComputedStyle(rebuyDropdown);
      if (style.display === 'none' || style.visibility === 'hidden' || rebuyDropdown.offsetParent === null) {
        rebuyDropdown.setAttribute('aria-hidden', 'true');
      }
    }
    
    // Fix age verification popup when not visible (Issue #13 item 2)
    var agePopup = document.getElementById('shopify-section-age-verification-popup');
    if (agePopup) {
      var modal = agePopup.querySelector('.modal');
      if (modal) {
        var isActive = modal.classList.contains('is-active') || modal.classList.contains('modal--is-active');
        if (!isActive) {
          agePopup.setAttribute('aria-hidden', 'true');
        }
      }
    }
    
    // Fix empty footer promotions section (Issue #13 item 7)
    var footerPromo = document.getElementById('shopify-section-footer-promotions');
    if (footerPromo) {
      var indexSection = footerPromo.querySelector('.index-section[aria-hidden="true"]');
      if (indexSection && indexSection.children.length === 0) {
        footerPromo.setAttribute('aria-hidden', 'true');
      }
    }
  }
  
  /**
   * Run all accessibility fixes
   */
  function runAllAccessibilityFixes() {
    fixVideoPlayButtons();
    fixCarouselNavigationRoles();
    fixGenericShopNowLinks();
    fixDecorativeSVGs();
    fixAriaHiddenOnContent();
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAllAccessibilityFixes);
  } else {
    runAllAccessibilityFixes();
  }
  
  // Re-run after page load (for third-party scripts)
  window.addEventListener('load', function() {
    setTimeout(runAllAccessibilityFixes, 500);
    setTimeout(runAllAccessibilityFixes, 2000);
  });
  
  // Monitor DOM changes for dynamically added elements
  var accessibilityObserver = new MutationObserver(function(mutations) {
    var shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check for video players, carousels, or other dynamic content
            if (node.classList && (
              node.classList.contains('video') ||
              node.classList.contains('carousel') ||
              node.classList.contains('modal') ||
              node.querySelector && (
                node.querySelector('video') ||
                node.querySelector('[class*="video"]') ||
                node.querySelector('[class*="carousel"]') ||
                node.querySelector('svg')
              )
            )) {
              shouldUpdate = true;
            }
          }
        });
      }
    });
    
    if (shouldUpdate) {
      setTimeout(runAllAccessibilityFixes, 100);
    }
  });
  
  // Start observing after a delay
  setTimeout(function() {
    accessibilityObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }, 1000);
  
  // Periodic check (fallback) - runs less frequently to avoid performance impact
  // Only runs the most critical fixes that handle dynamic content
  var checkCount = 0;
  var maxChecks = 6; // Stop after 30 seconds (6 checks * 5s)
  
  var periodicCheck = setInterval(function() {
    checkCount++;
    
    // Run lightweight checks
    fixVideoPlayButtons();
    fixCarouselNavigationRoles();
    fixDecorativeSVGs();
    
    // Stop periodic checks after 30 seconds to avoid unnecessary processing
    if (checkCount >= maxChecks) {
      clearInterval(periodicCheck);
    }
  }, 5000);
})();


